import axios from 'axios';

const url = "https://create-posts-app-server.onrender.com/posts"; 
// 'http://localhost:5000/posts'; 
// "https://frantic-gold-blazer.cyclic.app/";
// "https://create-posts-app.herokuapp.com/posts"; /*'http://localhost:5000/posts';*/

export const fetchPosts = () => axios.get(url);
export const createPost = (newPost) => axios.post(url, newPost);
export const likePost = (id) => axios.patch(`${url}/${id}/likePost`);
export const updatePost = (id, updatedPost) => axios.patch(`${url}/${id}`, updatedPost);
export const deletePost = (id) => axios.delete(`${url}/${id}`);
